import languages from '../languages';

const useEnglish = () => {
  return languages.english; // Fallback to English
};

export default useEnglish;